import { useState } from "react";
import CommonModal from "./DumpModal";
import InputField from "./InputField";
import UploadMethods from "./UploadMethods";
import ConfirmModal from "./ConfirmModal";
import { useUserInfo } from "../../../../../context/user";
import { useSubmitOnboarding } from "../../../../../queries/settingsAccount";


const UploadFileModal = ({
  isOpen,
  onClose,
  setModal,
  currentSource,
}) => {
  const [file, setFile] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const submitOnboarding = useSubmitOnboarding(userActiveLocation.id);
  const [loading, setLoading] = useState({
    uploadFile: false,
    confirmSubmit: false,
  });

  const handleConfirmModal = () => {
    setOpenConfirmModal(!openConfirmModal);
    setModal(false);
  };

  const handleConfirmClick = async () => {
    setLoading({ ...loading, confirmSubmit: true });
    if (file.length > 0) {
      try {
        const response = await submitOnboarding.mutateAsync({
          file_ids: file,
          profileId: userActiveLocation.id,
          username: userActiveLocation.business_name,
        });
        if (response) {
          setOpenConfirmModal(false);
        }
      } catch (err) {
        alert(err.message);
        console.log(err);
      }
    }
    setLoading({ ...loading, confirmSubmit: false });
  };
  return (
    <>
      <CommonModal onClose={onClose} isOpen={isOpen} title="Change File">
        <div className="mt-4">
          <label htmlFor="source" className="text-muted-foreground text-md">
            {!file ? "Current Source" : "Current file"}
          </label>
          <InputField
            id="source"
            value={
              currentSource?.website_url || currentSource?.file_name || "form"
            }
            disabled
            classNames="!bg-muted focus:!border-border"
          />
          {!file && !loading.uploadFile ? (
            <UploadMethods
              setFile={setFile}
              loading={loading}
              setLoading={setLoading}
            />
          ) : loading.uploadFile ? (
            <div className="w-full h-full mt-6 flex items-center justify-center">
              <div
                class="spinner"
                style={{
                  width: "50px",
                  height: "50px",
                  display: "inline-block",
                  marginRight: "8px",
                }}
              ></div>
            </div>
          ) : (
            <div className="mt-4">
              <label htmlFor="new-file" className="text-muted-foreground text-md">
                New file
              </label>
              <InputField
                id="new-file"
                value={file?.[0]}
                disabled
                classNames="!bg-muted focus:!border-border"
              />
              <button
                className={`mt-4 text-center w-full rounded-md py-3 text-lg bg-primary text-primary-foreground
          `}
                onClick={handleConfirmModal}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </CommonModal>
      <ConfirmModal
        isOpen={openConfirmModal}
        onClose={handleConfirmModal}
        title="Confirm Changes"
        onConfirm={handleConfirmClick}
        loading={loading.confirmSubmit}
      />
    </>
  );
};

export default UploadFileModal;
